import React, { forwardRef } from "react";

import { Select, Props as SelectProps } from "../Select";
import { countries, whitelistedCountries } from "../../../constants";

type Props = {
  excludeBlacklisted?: boolean;
} & Omit<SelectProps, "options">;

export const CountrySelect = forwardRef<HTMLDivElement, Props>(
  ({ excludeBlacklisted = false, onChange, placeholder, ...rest }, ref) => {
    return (
      <Select
        autoComplete
        options={excludeBlacklisted ? whitelistedCountries : countries}
        onChange={onChange}
        placeholder={placeholder || "Choose a country"}
        ref={ref}
        {...rest}
      />
    );
  }
);
